import { createSlice } from "@reduxjs/toolkit";
import {
  LAYOUT_TYPE_FULL,
  NAV_STYLE_MINI_SIDEBAR,
  THEME_COLOR_SELECTION_PRESET,
  THEME_TYPE_SEMI_DARK,
} from "../../constants/ThemeSetting";

const initialState = {
  navCollapsed: true,
  navStyle: NAV_STYLE_MINI_SIDEBAR,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  colorSelection: THEME_COLOR_SELECTION_PRESET,
  pathname: "",
  width: window.innerWidth,
  isDirectionRTL: false,
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    toggleCollapsedSideNav: (state, action) => {
      state.navCollapsed = action.payload;
    },
    updateWindowWidth: (state, action) => {
      state.width = action.payload;
    },
    setThemeType: (state, action) => {
      state.themeType = action.payload;
    },
    setThemeColor: (state, action) => {
      state.themeColor = action.payload;
    },
    onNavStyleChange: (state, action) => {
      state.navStyle = action.payload;
    },
    onLayoutTypeChange: (state, action) => {
      state.layoutType = action.payload;
    },
    switchLanguage: (state, action) => {
      state.locale = action.payload;
    },
    locationChange: (state, action) => {
      state.pathname = action.payload.location.pathname;
      state.navCollapsed = false;
    },
  },
});

export const {
  toggleCollapsedSideNav,
  updateWindowWidth,
  setThemeType,
  setThemeColor,
  onNavStyleChange,
  onLayoutTypeChange,
  switchLanguage,
  locationChange,
} = settingsSlice.actions;

export default settingsSlice.reducer;
